export default __webpack_public_path__ + "static/Plots0003-887d7811c7732ae43dbcacf0b67b09fb.jpg";